import * as React from 'react';

/** Строка рендерится как пункт списка (`li`); любой другой `ReactNode` — в отдельном `div` вне `ul`. */
export function isEmptyListPlainText(content: React.ReactNode): content is string {
  return typeof content === 'string';
}
